import { useQuery } from '@tanstack/vue-query';
import { useExperienceApi } from '@/shared/api/useExperienceApi.ts';
import { type MaybeRefOrGetter, unref, computed } from 'vue';
import { useLoaderStore } from '@/shared/store/useLoaderStore';

export const useTourInRegionFromCitySeoInfo = (
  regionSlug: MaybeRefOrGetter<string | undefined>,
  citySlug: MaybeRefOrGetter<string | undefined>,
  enabled: MaybeRefOrGetter<boolean>,
) => {
  const loaderStore = useLoaderStore();
  const { getSeoFromCityToRegion } = useExperienceApi();

  const { data: tourInRegionFromCitySeoData, isSuccess } = useQuery({
    queryKey: ['tourInRegionFromCitySeoInfo', citySlug, regionSlug],
    queryFn: async () => {
      const response = await getSeoFromCityToRegion({
        query: { ids: `${unref(citySlug) as string},${unref(regionSlug) as string}` },
      });

      loaderStore.check404(response);

      return response;
    },
    enabled: computed(() => !!unref(enabled)),
    select: (response) => response.data,
    retry: false,
  });

  return {
    tourInRegionFromCitySeoData,

    isSuccess,
  };
};
